import "./sentry.js";
import { save } from "./localstorage/control/StorageControl.js";
import { installFetchInterceptor } from "./loading/control/LoadingControl.js";
import { loadUser } from "./user/control/UserControl.js";
import { loadAppSettings } from "./navfooter/control/AppSettingsControl.js";
import { applyCustomTheme } from "./theme/control/ThemeControl.js";
import { initRouter } from "./router.js";
import './loading/boundary/Splash.js';
import './navigation/boundary/Header.js';
import './navigation/boundary/Darkmode.js';
import './language/boundary/Language.js';
import './notification/boundary/NotificationToast.js';
import './navfooter/boundary/Footer.js';
import './errors/boundary/Unauthorized.js';
import './errors/boundary/NotFound.js';
import store from "./store.js";

store.subscribe(_ => {
    const { darkmode } = store.getState();
    save({ darkmode });
});

installFetchInterceptor(store);

const userId = await loadUser();
if (userId) {
    await loadAppSettings(userId);
    await applyCustomTheme(userId);
}
document.body.classList.remove('is-invisible');
initRouter();